import React, { Component } from 'react';

import {
  SR_API_ACTION_ADMIN_GET_LISTING_TOUR_HEALTH_LIST, SR_API_ACTION_GET_TOUR_HEALTH,
} from 'api/actionTypes';

import withInfiniteScroll from 'client/helpers/withInfiniteScroll';
import withApiState from 'client/helpers/withApiState';

import branch from 'client/core/branch';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrToursHealth from 'client/components/SrToursHealth/SrToursHealth';

@withInfiniteScroll({
  offset: 420,
})
@withApiState({
  tourHealthListApiState: {
    action: SR_API_ACTION_ADMIN_GET_LISTING_TOUR_HEALTH_LIST,
  },
})
@branch({
  listingTourHealthList: ['listingTourHealthList'],
})
class SrTourHealthListView extends Component {
  constructor(props) {
    super(props);
    props.onInfiniteScrollCallbackReady(this._infiniteScrollCallback);
  }

  componentDidUpdate(prevProps) {
    const {
      dispatch,
    } = this.props;

    if (
      prevProps.marketId !== this.props.marketId
      || prevProps.partnerId !== this.props.partnerId
      || prevProps.accountManagerId !== this.props.accountManagerId
    ) {
      dispatch(({ state }) => {
        state.set('listingTourHealthList', {
          items: [],
          dataTableIsFullyLoaded: false,
        });
      });
    }
  }

  _infiniteScrollCallback = () => {
    const {
      dispatch,
      partnerId,
      marketId,
      accountManagerId,
      listingTourHealthList,
      tourHealthListApiState,
    } = this.props;

    if (listingTourHealthList.dataTableIsFullyLoaded || tourHealthListApiState.inProgress) {
      return;
    }

    const lastItem = listingTourHealthList.items.length
      ? listingTourHealthList.items[listingTourHealthList.items.length - 1]
      : null;

    dispatch(({ state, apiClient }) => {
      apiClient.postWithState({
        state: state,
        action: SR_API_ACTION_ADMIN_GET_LISTING_TOUR_HEALTH_LIST,
        payload: {
          partnerId,
          marketId,
          accountManagerId,
          afterListingId: lastItem?.listing.id,
        },
        onSuccess: (response) => {
          state.set(['listingTourHealthList'], {
            dataTableIsFullyLoaded: response.length < 6,
            items: [
              ...listingTourHealthList.items,
              ...response,
            ],
          });
        },
      });
    });
  }

  _onReloadDataTable = async (listingId) => {
    this.props.dispatch(({ state, apiClient }) => {
      apiClient.postWithState({
        state: state,
        action: SR_API_ACTION_GET_TOUR_HEALTH,
        payload: {
          listingId,
          includeListingNotes: true,
        },
        onSuccess: (listingResponse) => {
          const currentValue = state.get(['listingTourHealthList']);
          const newItems = currentValue
            .items
            .map((listingTourHealth) => {
              if (listingTourHealth.listing.id === listingId) {
                return {
                  ...listingTourHealth,
                  listing: {
                    ...listingTourHealth.listing,
                    notesCount: listingResponse.notesCount,
                  },
                };
              }

              return listingTourHealth;
            });

          state.set(['listingTourHealthList'], {
            ...currentValue,
            items: newItems,
          });
        },
      });
    });
  }

  render() {
    const {
      listingTourHealthList,
      tourHealthListApiState,
      onInfiniteScrollWrapperRef,
    } = this.props;

    return (
      <div ref={onInfiniteScrollWrapperRef}>
        <SrFlex wrap='wrap' justify='center'>
          {listingTourHealthList.items.map(({ listing, partner, market, tourHealth }) => {
            return (
              <SrBox key={listing.id} maxWidth='600px' padding='20px'>
                <SrToursHealth
                  showListingDetails
                  listing={listing}
                  partner={partner}
                  market={market}
                  tourHealth={tourHealth}
                  reloadListingNotes={this._onReloadDataTable}
                />
              </SrBox>
            );
          })}
        </SrFlex>
        {tourHealthListApiState.inProgress && (
          <SrBox margin='30px'>
            <div className='loading-gif' />
          </SrBox>
        )}
        {listingTourHealthList.dataTableIsFullyLoaded && listingTourHealthList.items.length === 0 && (
          <SrBox margin='60px' textAlign='center'>
            <SrText>Not Found Results</SrText>
          </SrBox>
        )}
      </div>
    );
  }
}

export default SrTourHealthListView;
